import { render, staticRenderFns } from "./yinjiangMap.vue?vue&type=template&id=74c497df&scoped=true&"
import script from "./yinjiangMap.vue?vue&type=script&lang=js&"
export * from "./yinjiangMap.vue?vue&type=script&lang=js&"
import style0 from "./yinjiangMap.vue?vue&type=style&index=0&id=74c497df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c497df",
  null
  
)

component.options.__file = "yinjiangMap.vue"
export default component.exports